module.exports = __webpack_public_path__ + "a2044247256bb063757cf34f43095bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_star_2x.png
// module id = 112
// module chunks = 0 1 2 3 4